import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { CompletedIcon } from '../../common/CompletedIcon';
import { formatEmailList, isClient } from '../../../helpers/global';

export const Completion = ({ isInternal, confirmationEmails, onClose }) => {
  const role = useMemo(() => localStorage.getItem('user-role'), []);

  const handleClick = () => {
    if (isInternal) {
      onClose();
    } else {
      window.location.href = 'https://accurateliensearch.net/';
    }
  };

  return (
    <div className="lein-search-container completion px-3">
      <div
        style={{
          display: 'flex',
          flex: 1,
          height: '100%',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CompletedIcon />
        <p className="order-type-section-title mt-5 mb-1">Order Successfully Submitted!</p>
        <p className="order-type-section-subtitle">Thank you for choosing Accurate.</p>
        <p className="order-type-section-subtitle">
          Your order is now being processed{' '}
          {confirmationEmails?.length > 0 ? (
            <>
              and the order confirmation email has been sent to <b>{formatEmailList(confirmationEmails)}.</b>
            </>
          ) : (
            ''
          )}
        </p>
        <Button
          size="lg"
          className="mt-5"
          onClick={handleClick}
          variant="dark"
          style={{ backgroundColor: 'darkblue', color: 'white' }}
        >
          {isInternal ? (
            <span>
              Return to <span>{isClient(role) ? 'Client' : ''}</span> Portal
            </span>
          ) : (
            <span>Return to Home</span>
          )}
        </Button>
      </div>
    </div>
  );
};
